import * as constants from '../../constants';
import { getConfig } from '../../reducers/portalConfig';
import { getValidationErrors } from '../../utils';
import axios from 'axios';

export const createEmailSettings = (payload) =>
  async (dispatch, getState) => {
    dispatch({
      type: constants.EMAIL_SETTINGS_CREATE_REQUEST,
      loading: true,
    })
    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal?.hostname}/admin/emailsettings/1.0`;
    await axios.put(url, payload, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.EMAIL_SETTINGS_CREATE_SUCCESS,
          payload: response.data,
        });
        dispatch({
          type: constants.FETCH_EMAIL_SETTINGS_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.EMAIL_SETTINGS_CREATE_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };


export const fetchEmailSettingsDetails = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal?.hostname}/admin/emailsettings/1.0`;
    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.FETCH_EMAIL_SETTINGS_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.FETCH_EMAIL_SETTINGS_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const replaceEmailSettings = (payload) =>
  async (dispatch, getState) => {
    dispatch({
      type: constants.FETCH_EMAIL_SETTINGS_REQUEST,
      loading: true,
    })
    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal?.hostname}/admin/emailsettings/1.0?replace=true`;
    await axios.put(url, payload, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.FETCH_EMAIL_SETTINGS_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.FETCH_EMAIL_SETTINGS_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchEmailSettingsCertificates = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal?.hostname}/admin/cert-management/1.0/certificates/`;
    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.FETCH_EMAIL_SETTINGS_CERTIFICATE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.FETCH_EMAIL_SETTINGS_CERTIFICATE_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };


  export const generateCsrCertificate = (payload) =>
  async (dispatch, getState) => {
    dispatch({
      type: constants.CREATE_CSR_CERTIFICATE_REQUEST,
      loading: true,
    })
    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal?.hostname}/admin/cert-management/1.0/certificates`;
    await axios.post(url, payload, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.CREATE_CSR_CERTIFICATE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.CREATE_CSR_CERTIFICATE_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

  export const validateClientCertificate = (payload, uuid) =>
  async (dispatch, getState) => {
    dispatch({
      type: constants.CLIENT_CERTIFICATE_REQUEST,
      loading: true,
    })
    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal?.hostname}/admin/cert-management/1.0/certificates/${uuid}`;
    await axios.put(url, payload, { credentials: 'include' })
      .then(() => {
        dispatch({
          type: constants.CLIENT_CERTIFICATE_SUCCESS,
          payload: true,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.CLIENT_CERTIFICATE_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

  export const replaceClientCertificate = (payload, uuid) =>
  async (dispatch, getState) => {
    dispatch({
      type: constants.CLIENT_CERTIFICATE_REQUEST,
      loading: true,
    })
    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal?.hostname}/admin/cert-management/1.0/certificates/${uuid}?replace=true`;
    await axios.put(url, payload, { credentials: 'include' })
      .then(() => {
        dispatch({
          type: constants.CLIENT_CERTIFICATE_SUCCESS,
          payload: true,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.CLIENT_CERTIFICATE_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };